// extracted by mini-css-extract-plugin
export default {"button":"ScrollButton_button__+rm0w"};